import MUITypography from '@material-ui/core/Typography'
import React, { CSSProperties } from 'react'

interface TypographyProps {
  variant?:
    | 'body1'
    | 'body2'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle1'
    | 'subtitle2'
    | 'button'
    | 'overline'
    | 'srOnly'
    | 'inherit'
  color?: 'primary' | 'secondary' | 'initial' | 'inherit'
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify'
  component?: React.ElementType
  className?: string
  style?: CSSProperties
}
export const Typography: React.FC<TypographyProps> = ({
  children,
  variant = 'body1',
  color = 'initial',
  align = 'left',
  component = 'p',
  className,
  style,
  ...dataAttributes
}) => {
  return (
    <MUITypography
      variant={variant}
      component={component}
      color={color}
      align={align}
      style={style}
      className={className}
      {...dataAttributes}
    >
      {children}
    </MUITypography>
  )
}
